import React from "react";
import { BookingStatsSection } from "./bookings-stat";
import { LoungeStatsSection } from "./lounge-stat";
import { SessionsStatsSection } from "./session.stat";
import { SlotsStatsSection } from "./slots-stat";
import { UsersStatsSection } from "./users-stat";
import { StatsPayload } from "../../types";

type Props = StatsPayload;

export const Sections: React.FC<Props> = ({ stats, expiry }) => {
  return (
    <div className="mt-10">
      <UsersStatsSection stats={stats.USERS} expiry={expiry.USERS} />
      <SessionsStatsSection stats={stats.SESSIONS} expiry={expiry.SESSIONS} />
      <SlotsStatsSection stats={stats.SLOTS} expiry={expiry.SLOTS} />
      <BookingStatsSection stats={stats.BOOKINGS} expiry={expiry.BOOKINGS} />
      <LoungeStatsSection stats={stats.LOUNGE} expiry={expiry.LOUNGE} />
    </div>
  );
};
